import React, { Component } from 'react';
 import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
 import { faHome } from '@fortawesome/free-solid-svg-icons';
 import { Link } from 'react-router-dom'
 import Aboutuslearners from '../Landing/Subcomponent/aboutuslearners';
 import Aluminicompany from '../Landing/Subcomponent/aluminicompany';
 import Whyedu from '../Landing/Subcomponent/whyedu';
 import { faBell } from '@fortawesome/free-solid-svg-icons';
import Intrestedinprogram from './intrestedinprogram';

class Insolvency extends Component {
    render() {
        return (
            <div>
                <div aria-label="breadcrumb">          
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"></li>
                        <li class="breadcrumb-item"><Link ><FontAwesomeIcon icon={faHome} />  &nbsp; HOME</Link></li>
                        <li class="breadcrumb-item active">Insolvency and Bankruptcy Code</li>
                    </ol>
                </div>

                <section class="course-header bg-blue1" id="course-header">
                    <div class="row">
                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
                                <h1>Insolvency and Bankruptcy Code</h1>
                                <p>Decoding India’s Insolvency and Bankruptcy Code, 2016</p>
                                <br />
                                <br />
                                <div class="row">
                                    <button class="pulse-button" type="button" data-toggle="modal"  data-target="#myModalq" onclick="startvideo()"></button>
                                    <p class="Watch-Intro">Watch Intro Video </p>
                                </div>
                                <br />
                                <div class="form-group">
                                <a href="#apply-now" class="btn btn-md enroll-btn">Enroll Now </a>
                                    
                                    <button type="button" class="btn btn-md download-bro-btn" data-toggle="modal" id="myBtn"
                                        data-target="#myModal" onclick="return gtag_report_conversion('<?php echo $baseurl;?>course/insolvency-and-bankruptcy-code');">Download
                                        brochure</button><br />  <br /> <br /> 
                                  
                                </div>
                            </div>
                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-1"></div>
                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-5">
                                <p>Jointly Delivered by </p>
                                <ul>
                                    <li><img width="200px" src="/assets/images/epn.svg"   alt="Plus Logo"/></li>  
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                   <li >
                                       <img width="100px" height="75px;" src="/assets/images/icons/guru&jana.jpg" alt="Guru & Jana CA"/></li>
                                       <br />
                                
                                </ul>
                                <br />
                            </div>
                        </div>
                </section> 
                <div class="course-main-contains def-z" id="Description" >
                    <div class="card">
                        <div class="row contanint-display">
                            <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4">    
                            <b>What's included : <br />
                            <i class="fa fa-mobile" ></i> &nbsp;&nbsp;Mobile Support</b>  
                            </div>
                            <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4">    
                            <b><i class="fa fa-comments" ></i>&nbsp; Discussion Forum</b><br />
                            <b><i class="fa fa-certificate" ></i> &nbsp; Course Certificate</b>
                            </div>
                            <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4"   >    
                            <b><i class="fa fa-question" ></i> &nbsp;&nbsp;&nbsp;Quiz</b><br />
                         
                            </div>
                        </div>
                    </div>
                </div>

                <section class="def-z">
                    <div class="header" id="myHeader">
                            <ul>
                                <li><a href="#Description">Description</a></li>
                                <li><a href="#course-description">Eligibility</a></li>
                                <li><a href="#Syllabus">Syllabus</a></li>            
                                <li><a href="#Outcomes">Learning Outcomes</a></li>           
                                <li><a href="#Reviews">Learner Review </a></li>          
                                <li><a href="#Instructor">About Instructor</a></li>
                                <li class="btn-header cs-dx"><a href="#apply-now">Enroll Now</a></li>              
                            </ul>
                    </div>
                </section> 

                <section class="course-description" id="course-description">
                       <br />
                        <div class="row">
                            <div class="col-sm-12">
                                <h3>Description</h3>
                                <p align="justify">The course on Insolvency and Bankruptcy Code presents the in-details concept and procedure of the insolvency and liquidation process.</p>
                                <br />
                            </div>
                           
                        </div> 
                        <h3 class="heading-tab">Who Should Enroll?</h3>
                        <div class="row">
                            <div class="col-sm-6">
                                <ul class="highlight-ul">
                                    <li>Gradate / Postgraduate students in field of finance, commerce and law</li>
                                    <li>Practicing Professionals</li>
                                    <li>Corporate Executives / Managers</li>
                                    <li>Start-up Founders and Business Owners</li>
                                </ul>
                            </div>
                            <div class="col-sm-6">
                                <ul class="highlight-ul">
                                    <li>Angel/VC/PE Investors and Advisors</li>
                                    <li id="Syllabus">Academicians</li>
                                    <li>Any other finance enthusiasts</li>
                                    <li>Please note: Trainee must have graduate in field of finance/commerce/law</li>
                                </ul>
                            </div>
                        </div>
                </section>

                <section class="course-syllabus" id="course-syllabus">
                    <div class="row">
                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-10">
                         <h3> Syllabus </h3>
                         <br />
                         <div class="syl-bg">
                         <div id="de_syllabus">
                             <div class="panel-group">
                                 <div class="panel panel-info">
                                     <div class="panel-heading" id="de_heading1" data-toggle="collapse"
                                         href="#de_syllabus1" aria-expanded="true" aria-controls="de_syllabus1">
                                         <h6 class="panel-title"><i class="indicator fa fa-minus"></i> Section  1 
                                         </h6>
                                     </div>

                                     <div id="de_syllabus1" class="collapse show" aria-labelledby="de_heading1"
                                         data-parent="#de_syllabus">
                                         <div class="panel-body">
                                             <ul class="syllabus-ul" >
                                                 <li>Insolvency and Bankruptcy Code-2016 - General Overview Part II - Insolvency Resolution And Liquidation For Corporate Persons - Chapter II, III</li>
                                            </ul>
                                         </div>
                                     </div>
                                 </div>
                                
                                 <div class="panel panel-info">
                                     <div class="panel-heading" id="de_heading2" data-toggle="collapse"
                                         href="#de_syllabus2" aria-expanded="true" aria-controls="de_syllabus2">
                                         <h6 class="panel-title">
                                             <i class="indicator fa fa-minus"></i> Section  2
                                         </h6>
                                     </div>

                                     <div id="de_syllabus2" class="collapse show" aria-labelledby="de_heading2"
                                         data-parent="#de_syllabus">
                                         <div class="panel-body">
                                             <ul class="syllabus-ul">
                                                 <li> Part II - Insolvency Resolution And Liquidation For Corporate Persons - Chapter III</li>
                                             </ul>
                                         </div>
                                     </div>
                                 </div>

                                 <div class="panel panel-info">
                                     <div class="panel-heading" id="de_heading3" data-toggle="collapse"
                                         href="#de_syllabus3" aria-expanded="true" aria-controls="de_syllabus3">
                                         <h6 class="panel-title">
                                             <i class="indicator fa fa-minus"></i>Section  3
                                         </h6>
                                     </div>

                                     <div id="de_syllabus3" class="collapse show" aria-labelledby="de_heading3"
                                         data-parent="#de_syllabus">
                                         <div class="panel-body">
                                             <ul class="syllabus-ul">
                                                 <li>Part III - Insolvency resolution and bankruptcy for individuals and partnership firms - Chapter I, II, III, IV, V, VI, VII</li>
                                             </ul>
                                         </div>
                                     </div>
                                 </div>
                              
                                 <div class="panel panel-info">
                                     <div class="panel-heading" id="de_heading4" data-toggle="collapse"
                                         href="#de_syllabus4" aria-expanded="true" aria-controls="de_syllabus4">
                                         <h6 class="panel-title">
                                             <i class="indicator fa fa-minus"></i>Section  4
                                         </h6>
                                     </div>

                                     <div id="de_syllabus4" class="collapse show" aria-labelledby="de_heading4"
                                         data-parent="#de_syllabus">
                                         <div class="panel-body">
                                             <ul class="syllabus-ul">
                                                 <li>Part III - Insolvency resolution and bankruptcy for individuals and partnership firms - Chapter IV</li>
                                             </ul>
                                         </div>
                                     </div>
                                 </div>

                                 <div class="panel panel-info">
                                     <div class="panel-heading" id="de_heading5" data-toggle="collapse"
                                         href="#de_syllabus5" aria-expanded="true" aria-controls="de_syllabus5">
                                         <h6 class="panel-title">
                                             <i class="indicator fa fa-minus" id="Outcomes"></i>Section  5
                                         </h6>
                                     </div>

                                     <div id="de_syllabus5" class="collapse show" aria-labelledby="de_heading5"
                                         data-parent="#de_syllabus">
                                         <div class="panel-body">
                                             <ul class="syllabus-ul">
                                                 <li>Part III - Insolvency resolution and bankruptcy for individuals and partnership firms - Chapter V</li>
                                             </ul>
                                         </div>
                                     </div>
                                 </div>
                             </div> 
                         </div> 
                     </div> 
                     </div> 
               </div>
             </section> 
             <section class="course-learning-outcome bg-secondary " id="course-learning-outcome">
                    <div class="row">
                        <div class="col-sm-6">
                            <h3>Learning Outcomes</h3>
                            <ul class="lo-ul">
                                <li>Ability to perform insolvency work and be at ease with insolvency aspects of corporate transactions</li>
                                <li>Learn to manage expectations of stakeholders and parties in a restructuring/liquidation</li>
                            </ul>
                            <br />
                            <h3>Assessment Policy</h3>
                            <div class="table-responsive course-batch-schedule"> 
                                <div class="card">
                                    <table class="table">
                                        <thead>
                                            <tr class="text-center">
                                                <th >Type</th>
                                                <th >Weightage %</th>
                                            </tr>
                                        </thead>
                                        <tbody class="content-size">
                                            <tr>
                                                <td id="Reviews">Content</td>
                                                <td >100%</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                </div>
                        </div>
                        <div class="col-sm-6">
                            <img src="/assets/images/icons/certificate1.png" alt="executive2"/>
                        </div>
                    </div>
                    <br/><br/>
                </section>
                <section class="course-admission-process"> 
               
                </section>
                <Aboutuslearners />
                <Aluminicompany />
            

            <section class="courses-feesm">
            <section class="course-fees" id="course-fees">
                <div class="row box-sh" >
                   <div class="col-sm-12 col-lg-12	col-xl-5  pd-fee" >
                        <Intrestedinprogram/>   
                      </div>
                    <div class="vertical-line-fee"> </div>
                    <div class="col-sm-12 col-lg-12 col-xl-6 pd-fee">
                        <div class="row">
                            <div class="col-sm-10"> <br /><br />
                                <h5>Features</h5>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 col-sm-12">
                              <ul class="highlight-ss" >
                                <li> Guru and Jana as the knowledge partner</li>
                                <li> Mentorship by industry specialists</li>
                                <li> Seamless EMI options</li>
                                <li> Industry-oriented curriculum</li>
                              </ul>
                            </div>
                            <p>{// eslint-disable-next-line
                                    }<marquee onmouseover="this.stop();" onmouseout="this.start();" class="marquee-enroll" >"If a group of four or more participants enroll with us, a concession of 10% will be awarded to each one of them. For more details Contact us."<a href="tel://8956167195 "> &nbsp;&nbsp;<i class="fa fa-mobile" aria-hidden="true"></i> +91 8956167195</a></marquee>
                           </p>   
                        </div> 
                        </div>
                </div>
             </section> 
             </section> 
             <Whyedu />

            <section class="course-about-instructor bg-secondary " id="course-about-instructor" >
                <div class="row">
                    <div class="col-sm-12">
                         <h3>About the Instructor</h3>
                        <br />
                        <div class="about-ist">
                            <div class="card pd-abt-ist">
                                <div class="social-instructor">
                                   <img onerror="this.onerror=null;this.src='https://s3.ap-south-1.amazonaws.com/myeduplusnow/person/default_avatar.jpg';" alt="" src="https://s3.ap-south-1.amazonaws.com/myeduplusnow/person/26_GuruPrasad.jpg" />
                                </div>
                                <div class="inst-details">
                                    <h3>Guru Prasad</h3>
                                    <p>30 Years Of Experience</p>
                                    <br />            
                                        <h4>Guru and Jana</h4>
                                    <p align="justify">Guru is the Founding Partner and heads the Consulting Team and Indirect Tax Team at Guru and Jana. The firm has a unique way of life and character, which, led by Guru, leads to thought leadership, empowerment and action. A Chartered Accountant with a degree in law and commerce, Guru brings over 20 years of experience to the firm. With a calm business head, he specialises in business advisory services and heads the strategy and business development front of the firm. An alumnus of the Indian Institute of Management, he also holds a diploma in counseling. Guru has been a member of the Auditing Standards Board of ICAI and has authored seven technical guides on internal audit. He has published a book ‘Banter Beyond The Buck’ and is an avid global traveler and Tabla player. He represents India subcontinent in the HLBI Global Tech Group. He is also a Board Adviser to Vishwakarma University Pune [Autonomous].</p>
                                    <br />
                                    <ul class="course-about-ul">
                                            <li >
                                                <a href="https://www.facebook.com/guruprasad.makam" target="_blank"  rel="noreferrer">
                                                <FontAwesomeIcon icon={faBell} />
                                                </a>
                                            </li>
                                            <li >
                                                <a href="https://www.linkedin.com/in/guru-prasad-58b9b913/ @guruprasadmakam" target="_blank" rel="noreferrer" >
                                                <FontAwesomeIcon icon={faBell} />
                                                </a>
                                            </li>
                                            <li >
                                                <a href="https://twitter.com/guruprasadmakam " target="_blank"  rel="noreferrer">
                                                <FontAwesomeIcon icon={faBell} />
                                                </a>
                                            </li>
                                           
                                    </ul>
                                </div>
                            </div>
                        </div>
                            <br /><br />
                        <div class="about-ist">
                            <div class="card pd-abt-ist">
                                <div class="social-instructor">
                                    <img   onerror="this.onerror=null;this.src='https://s3.ap-south-1.amazonaws.com/myeduplusnow/person/default_avatar.jpg';" alt="" src="https://s3.ap-south-1.amazonaws.com/myeduplusnow/person/27_Srilakshmi(1).jpg" />
                                </div>
                                <div class="inst-details">
                                    <h3>Srilakshmi</h3>
                                        <p>10 Years Of Experience</p>
                                        <br />
                                        <h4>Guru and Jana</h4>
                                        <p align="justify">Sri heads the corporate governance team of the firm. A Chartered Accountant and a Company Secretary, Srilakshmi holds a Master’s Degree in Psychology too. She has received the Gold Medal from Azim Premji in her Bachelor of Commerce and brings to the table experience from her brief stint with BMR Associates. Sri is key to Guru and Jana’s core belief that happy organisation gives greater satisfaction to its clients. Sri leads this process through the recruitment and reward culture. Sri also spearheads the core belief of the firm that delivering to the client in a professional manner is vital. Based on this philosophy, Sri drives a unique product called VIVID, the IP of which belongs to Guru & Jana. This product engages with the user to roll out high quality presentation of documentation in a few minutes.</p>
                                    <br />
                                    <ul class="course-about-ul">
                                            <li >{// eslint-disable-next-line
                                    } <a href="#"   >
                                                <FontAwesomeIcon icon={faBell} />
                                                </a>
                                            </li>
                                            <li >{// eslint-disable-next-line
                                    }<a href="https://www.linkedin.com/in/srilakshmi-p-204a97a2/" target="_blank" rel="noreferrer" >
                                                <FontAwesomeIcon icon={faBell} />
                                                </a>
                                            </li>
                                            <li >{// eslint-disable-next-line
                                    } <a href="#"><FontAwesomeIcon icon={faBell} />
                                                </a>
                                            </li>
                                            <li >{// eslint-disable-next-line
                                    }<a href="#"  target=""><i class="fa fa-instagram" target="_blank"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                            <br /><br />
                        <div class="about-ist">
                            <div class="card pd-abt-ist">
                                <div class="social-instructor">
                                <img   onerror="this.onerror=null;this.src='https://s3.ap-south-1.amazonaws.com/myeduplusnow/person/default_avatar.jpg';" alt="" src="https://s3.ap-south-1.amazonaws.com/myeduplusnow/person/28_Vijayraja.jpg" />
                                </div>
                                <div class="inst-details">
                                    <h3>Vijay Raja</h3>
                                        <p>15 Years Of Experience</p>
                                        <br />
                                        <h4>Guru and Jana</h4>
                                        <p align="justify">Raja heads training and knowledge enhancement in the firm and is a creative, passionate advocate of ethical living. His unique and inspiring ‘Extra Gyan’ sessions have motivated many, and he has extended his knowledge to over 35,000 students who have given him great pride in their exceptional achievements. Professionally he is qualified as a Chartered Accountant, Cost Accountant,Company Secretary and holds a Master’s Degree in Commerce and Psychology, as well as a Bachelor’s Degree in Law. Raja is also an author, and has written books on corporate law, ethics and business communication and as a philanthropist, he is the creator of the Mahatria Guru Jana Foundation. Training and teaching is his passion.</p>                  
                                    <br />
                                    <ul class="course-about-ul">
                                            <li >{// eslint-disable-next-line
                                            }<a href="https://www.facebook.com/vijayrajasir/" target="_blank" rel="noreferrer">
                                                <FontAwesomeIcon icon={faBell} />
                                                </a>
                                            </li>
                                            <li >{// eslint-disable-next-line
                                            }<a href="https://www.linkedin.com/in/vijayraja/" target="_blank"  rel="noreferrer">
                                                <FontAwesomeIcon icon={faBell} />
                                                </a>
                                            </li>
                                            <li >{// eslint-disable-next-line
                                            }<a href="#"   >
                                                <FontAwesomeIcon icon={faBell} />
                                                </a>
                                            </li>
                                                    <li >{// eslint-disable-next-line
                                            }<a href="#"  target="">
                                                        <FontAwesomeIcon icon={faBell} />
                                                        </a>
                                                    </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                                    
                     </div>
               </div>     
            </section>
            <div class="modal fade" id="myModalq" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
               <div class="modal-dialog  modal-xl" role="document">
                  <div class="modal-content">
                     <div class="modal-body">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" onclick="stopvideo()">
                        <span class="colse-icon" aria-hidden="true">&times;</span>
                        </button>        
                       
                        <div class="embed-responsive embed-responsive-21by9">
                           <video controls="true" class="embed-responsive-item" id="video">
                              <source src="https://s3.ap-south-1.amazonaws.com/eduplusnowlive1/course/32/27/video/Introduction.mp4"  type="video/mp4" />
                           </video>
                        </div>
                     </div>
                  </div>
               </div>
            </div>

            <div class="modal fade bd-example-modal-sm" id="myModal" role="dialog" >
                <div class="modal-dialog modal-md">
                    <div class="modal-content">
                        <div class="modal-header" >
                             <span class="close" id="close_form"
                                   data-dismiss="modal">&times;</span>
                                    <br />
                        </div>
                        <div class="modal-body" >
                            <div class="panel panel-default paper-shadow box_detail" >
                                 <h5 class="text-center "> Download The Course Brochure </h5>
                                <form method="post" class="form-row"  onsubmit="return validate()">
                                    <b>Your Name</b><input class="form-control" pattern="[A-Za-z ]{1,32}" type="text"
                                            required="" autocomplete="on" name="name" id="name"/>
                                     <b>Your email</b><input class="form-control" type="email" required=""
                                         autocomplete="on" name="emaill" id="emaill" />
                                     <b>Your Contact No</b><input class="form-control" pattern="[7-9]{1}[0-9]{9}"
                                         type="tel" required="" autocomplete="on" name="contactt" id="contactt" />
                                     <input type="hidden" name="id" id="exd-course-name" value='<?php echo $words[0]; ?>' />     
                                     <input type="hidden" id="backurl" value="<?php echo $backurl?>" />
                                     <br />
                                     <div>
                                         <div class="form-group">
                                            <div  id="recaptcha" class="g-recaptcha"
                                                data-sitekey="6Lejh30UAAAAAPhZirvpXtobtIE80K7NUzsDqKjE"></div>
                                                <div id="captcha"></div>
                                            </div>
                                        </div>
                                        <div class="mob_cb">

                                         <div>
                                         </div><br />
                                         <button class="btn_1 rounded" type="button" onclick="getbroucher(<?php echo '\''.$filepath.'\'';?>)"  id="exd-download" ><i class="icon-download"></i> Brochure</button></div>
                                         <br />
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


           </div>
            
        );
    }
}

export default Insolvency;